import ZustandDadosDeFinanciamento from "../../Zustand/ZustandDadosDeFinanciamento";
import GenerateQuestion from "../GenereteQuestion/GeneratQuestion";
import FormBank from "./FormBank/FormBank";
import FormBankMoreBanks from "./FormBank/FormBankMoreBanks";
import FormBankMobile from "./FormBankMobile/FormBankMobile";
import "./FormFinancingBank.css";
import { Container, Row, Col, Table, Form } from "react-bootstrap";
import React, { useState } from "react";
import ZustandSelectBankType from "../../Zustand/ZustandSelectBankType";
import ZustandFormImovel from "../../Zustand/ZustandFormImovel";
import ZustandProductCgi from "../../Zustand/ZustandProductCgi";
import ZustandFinancingBank from "../../Zustand/ZustandFinancingBanks";
import { WarningLTV } from "./FormBank/Components/Warning";

const FormFinancingBank = (props) => {
  const {
    taxaBrb,
    taxaBradesco,
    taxaCaixa,
    taxaInter,
    taxaSantander,
    taxaItau,
    setTaxaBrb,
    setTaxaBradesco,
    setTaxaCaixa,
    setTaxaInter,
    setTaxaSantander,
    setTaxaItau,
  } = ZustandDadosDeFinanciamento();

  const { valorDoImovel, valorFGTS, valorDeEntrada } = ZustandFormImovel();

  const { cgi } = ZustandProductCgi();

  const valorFinanciamento = valorDoImovel - valorDeEntrada - valorFGTS;
  const calculo = (valorFinanciamento / valorDoImovel) * 100;

  const { selectInter } = ZustandSelectBankType();

  const {
    setButtonTaxItauIsSelect,
    setButtonTaxBradescoIsSelect,
    setButtonTaxCaixaIsSelect,
    setButtonTaxInterIsSelect,
    setButtonTaxSantanderIsSelect,
    setButtonTaxBrbIsSelect,
    buttonTaxIsErro,
  } = ZustandFinancingBank();

  const handleSelectBrb = (id) => {
    if (taxaBrb !== id) {
      setButtonTaxBrbIsSelect(true);
      setTaxaBrb(id);
    } else {
      setButtonTaxBrbIsSelect(false);
      setTaxaBrb(0);
    }
  };

  const handleSelectBradesco = (id) => {
    if (taxaBradesco !== id) {
      setButtonTaxBradescoIsSelect(true);
      setTaxaBradesco(id);
    } else {
      setButtonTaxBradescoIsSelect(false);
      setTaxaBradesco(0);
    }
  };

  const handleSelectCaixa = (id) => {
    if (taxaCaixa !== id) {
      setButtonTaxCaixaIsSelect(true);
      setTaxaCaixa(id);
    } else {
      setButtonTaxCaixaIsSelect(false);
      setTaxaCaixa(0);
    }
  };

  const handleSelectInter = (id) => {
    if (taxaInter !== id) {
      setButtonTaxInterIsSelect(true);
      setTaxaInter(id);
    } else {
      setButtonTaxInterIsSelect(false);
      setTaxaInter(0);
    }
  };

  const handleSelectSantander = (id) => {
    if (taxaSantander !== id) {
      setButtonTaxSantanderIsSelect(true);
      setTaxaSantander(id);
    } else {
      setButtonTaxSantanderIsSelect(false);
      setTaxaSantander(0);
    }
  };

  const handleSelectItau = (id) => {
    if (taxaItau !== id) {
      setButtonTaxItauIsSelect(true);
      setTaxaItau(id);
    } else {
      setButtonTaxItauIsSelect(false);
      setTaxaItau(0);
    }
  };

  const firstTaxBrb = "11.34%";
  const secondTaxBrb = "11.45%";
  const thirdTaxBrb = "12.00%";

  const firstTaxBradesco = "13.50%";
  const secondTaxBradesco = "13.50%";
  const thirdTaxBradesco = "13.50%";

  const firstTaxCaixa = "11.19%";
  const secondTaxCaixa = "11.29%";
  const thirdTaxCaixa = "11.49%";

  const firstTaxInter = "15.00%";
  const firstTaxInterFin = "9.50%";
  const fisrtTaxInterCGI = "13.89%";

  const firstTaxSantander = "12.39%";
  const secondTaxSantander = "13.59%";

  const taxPrivateItau = "12.09%";
  const taxPersonnalite4e5Itau = "12.19%";
  const taxPersonnalite1e3Itau = "12.39%";
  const taxUniclass4e5Itau = "12.69%";
  const taxUniclass1e3Itau = "13.09%";
  const taxBalcaoItau = "13.69%";

  let valorImovelComValorEntrada = valorDoImovel - valorDeEntrada - valorFGTS;
  let calculoLTV70 = (Number(valorImovelComValorEntrada) / Number(valorDoImovel)) * 100;

  let ltvAceito = calculoLTV70 > 70;

  return (
    <Container className="custom-margin-left mt-5 p-0 mb-2" fluid>
      <Row className="d-flex align-items-start flex-wrap">
        <Col
          xs={12}
          lg={3}
          className="d-flex justify-content-center align-items-center p-0 px-4 px-md-0"
        >
          <GenerateQuestion
            header="Dados do financiamento"
            subheader="Ao lado, nossa plataforma multibancos pesquisará em diferentes instituições financeiras onde o crédito está mais interessante para seu financiamento."
          />
        </Col>
        <Col
          xs={1}
          sm={1}
          md={1}
          lg={1}
          className="d-none d-md-block my-2 mx-1"
        ></Col>
        {selectInter === "Multibancos" ? (
          <>
            <Col
              className="d-none d-md-block"
              style={{ padding: "0px 0px 0px 16px " }}
            >
              {calculo > 70 ? (
                <FormBank
                  src="./assets/brb.svg"
                  secondNameTax="Bonificada"
                  thirdNameTax="Balcão"
                  firstTax={firstTaxBrb}
                  secondTax={secondTaxBrb}
                  thirdTax={thirdTaxBrb}
                  secondId={26}
                  thirdId={1}
                  color={props.color}
                  onSelect={handleSelectBrb}
                  height="100%"
                  witdh="25%"
                />
              ) : (
                <FormBank
                  src="./assets/brb.svg"
                  firstNameTax="Bonificada"
                  thirdNameTax="Balcão"
                  firstTax={firstTaxBrb}
                  thirdTax={thirdTaxBrb}
                  firstId={24}
                  thirdId={1}
                  color={props.color}
                  onSelect={handleSelectBrb}
                  height="100%"
                  witdh="25%"
                />
              )}
              {ltvAceito && valorFinanciamento.length != 0 ? (
                <FormBank
                  src="./assets/bradesco.svg"
                  firstNameTax="Bradesco Private / Principal"
                  secondNameTax="Bradesco Prime / Exclusive"
                  thirdNameTax="Bradesco Classic"
                  firstTax={firstTaxBradesco}
                  secondTax={secondTaxBradesco}
                  thirdTax={thirdTaxBradesco}
                  onSelect={handleSelectBradesco}
                  color={props.color}
                  firstId={6}
                  secondId={20}
                  disabled={true}
                  thirdId={21}
                  height="50%"
                  witdh="50%"
                />
              ) : (
                <FormBank
                  src="./assets/bradesco.svg"
                  firstNameTax="Bradesco Private / Principal"
                  secondNameTax="Bradesco Prime / Exclusive"
                  thirdNameTax="Bradesco Classic"
                  firstTax={firstTaxBradesco}
                  secondTax={secondTaxBradesco}
                  thirdTax={thirdTaxBradesco}
                  onSelect={handleSelectBradesco}
                  color={props.color}
                  firstId={6}
                  secondId={20}
                  thirdId={21}
                  height="50%"
                  witdh="50%"
                />
              )}
              {ltvAceito && valorFinanciamento.length != 0 ? (
                <FormBank
                  src="./assets/caixa.svg"
                  firstNameTax="Plus"
                  secondNameTax="Relacionamento"
                  thirdNameTax="Balcão"
                  firstTax={firstTaxCaixa}
                  secondTax={secondTaxCaixa}
                  thirdTax={thirdTaxCaixa}
                  firstId={30}
                  disabled={true}
                  secondId={7}
                  thirdId={33}
                  color={props.color}
                  onSelect={handleSelectCaixa}
                  height="50%"
                  witdh="50%"
                />
              ) : (
                <FormBank
                  src="./assets/caixa.svg"
                  firstNameTax="Plus"
                  secondNameTax="Relacionamento"
                  thirdNameTax="Balcão"
                  firstTax={firstTaxCaixa}
                  secondTax={secondTaxCaixa}
                  thirdTax={thirdTaxCaixa}
                  firstId={30}
                  secondId={7}
                  thirdId={33}
                  color={"#B9BBBF"}
                  onSelect={handleSelectCaixa}
                  height="50%"
                  witdh="50%"
                />
              )}
              <FormBank
                src="./assets/inter.svg"
                firstNameTax="Balcão"
                firstTax={firstTaxInter}
                firstId={12}
                onSelect={handleSelectInter}
                color={props.color}
                height="25%"
                witdh="25%"
              />
              <FormBank
                src="./assets/santander.svg"
                firstNameTax="Taxa Mínima"
                secondNameTax="Taxa Máxima"
                firstTax={firstTaxSantander}
                secondTax={secondTaxSantander}
                firstId={4}
                secondId={23}
                onSelect={handleSelectSantander}
                color={props.color}
                height="25%"
                witdh="25%"
              />
              <div>
                <FormBankMoreBanks onSelect={handleSelectItau} />
                {buttonTaxIsErro && (
                  <p
                    style={{
                      fontSize: "12px",
                      fontWeight: "400",
                      fontFamily: "inter",
                      letterSpacing: "0px",
                      lineHeight: "normal",
                      color: "RED ",
                    }}
                  >
                    * Por favor, selecione um banco
                  </p>
                )}

                <Col>
                  <p
                    style={{
                      fontSize: "12px",
                      fontWeight: "400",
                      fontFamily: "inter",
                      letterSpacing: "0px",
                      lineHeight: "normal",
                    }}
                  >
                    A simulação de financiamento é apenas uma estimativa. As
                    condições reais (valores, taxas e parcelas) só são definidas
                    após a análise de crédito. Custos como avaliação do imóvel
                    podem ser cobrados mesmo em caso de desistência. Todos os
                    valores estão sujeitos a mudanças conforme o perfil do
                    cliente, correções monetárias e regras do banco. Ao apertar
                    em Simular, você confirma que entende esses termos.
                  </p>
                  {ltvAceito && valorFinanciamento.length != 0 ? (
                    <div>
                      <WarningLTV
                        name="Bradesco"
                        warning="Aceita somente LTV abaixo de 70%"
                      />
                      <WarningLTV
                        name="Caixa"
                        warning="Aceita somente LTV abaixo de 70%"
                      />
                    </div>
                  ) : null}
                </Col>
              </div>
            </Col>
          </>
        ) : cgi === "FIN" && selectInter === "INTER" ? (
          <Col
            className="d-none d-md-block"
            style={{ padding: "0px 0px 0px 16px " }}
          >
            <div className="d-none d-md-block">
              <FormBank
                src="./assets/inter.svg"
                firstNameTax="IPCA"
                firstTax={firstTaxInterFin}
                firstId={12}
                onSelect={handleSelectInter}
                color={props.color}
                height="25%"
                witdh="25%"
              />
              <Col>
                <p
                  style={{
                    fontSize: "12px",
                    fontWeight: "400",
                    fontFamily: "inter",
                    letterSpacing: "0px",
                    lineHeight: "normal",
                    color: "RED ",
                  }}
                >
                  {buttonTaxIsErro && (
                    <p
                      style={{
                        fontSize: "12px",
                        fontWeight: "400",
                        fontFamily: "inter",
                        letterSpacing: "0px",
                        lineHeight: "normal",
                        color: "RED ",
                      }}
                    >
                      * Por favor, selecione um banco
                    </p>
                  )}
                </p>
                <p
                  style={{
                    fontSize: "12px",
                    fontWeight: "400",
                    fontFamily: "inter",
                    letterSpacing: "0px",
                    lineHeight: "normal",
                  }}
                >
                  A simulação de financiamento é apenas uma estimativa. As
                  condições reais (valores, taxas e parcelas) só são definidas
                  após a análise de crédito. Custos como avaliação do imóvel
                  podem ser cobrados mesmo em caso de desistência. Todos os
                  valores estão sujeitos a mudanças conforme o perfil do
                  cliente, correções monetárias e regras do banco. Ao apertar em
                  Simular, você confirma que entende esses termos.
                </p>
              </Col>
            </div>
          </Col>
        ) : cgi === "CGI" && selectInter === "INTER" ? (
          <Col
            className="d-none d-md-block"
            style={{ padding: "0px 0px 0px 16px " }}
          >
            <div className="d-none d-md-block">
              <FormBank
                src="./assets/inter.svg"
                firstNameTax="IPCA"
                firstTax={fisrtTaxInterCGI}
                firstId={12}
                onSelect={handleSelectInter}
                color={props.color}
                height="25%"
                witdh="25%"
              />
              <Col>
                {buttonTaxIsErro && (
                  <p
                    style={{
                      fontSize: "12px",
                      fontWeight: "400",
                      fontFamily: "inter",
                      letterSpacing: "0px",
                      lineHeight: "normal",
                      color: "RED ",
                    }}
                  >
                    * Por favor, selecione um banco
                  </p>
                )}
                <p
                  style={{
                    fontSize: "12px",
                    fontWeight: "400",
                    fontFamily: "inter",
                    letterSpacing: "0px",
                    lineHeight: "normal",
                  }}
                >
                  A simulação de financiamento é apenas uma estimativa. As
                  condições reais (valores, taxas e parcelas) só são definidas
                  após a análise de crédito. Custos como avaliação do imóvel
                  podem ser cobrados mesmo em caso de desistência. Todos os
                  valores estão sujeitos a mudanças conforme o perfil do
                  cliente, correções monetárias e regras do banco. Ao apertar em
                  Simular, você confirma que entende esses termos.
                </p>
              </Col>
            </div>
          </Col>
        ) : null}
        {selectInter === "Multibancos" ? (
          <Col className=" d-md-none m-2">
            {calculo > 0.7 ? (
              <FormBankMobile
                src="./assets/brb.svg"
                secondNameTax="Bonificada LTV > 70%"
                thirdNameTax="Balcão"
                firstTax={firstTaxBrb}
                secondTax={secondTaxBrb}
                thirdTax={thirdTaxBrb}
                secondId={26}
                thirdId={1}
                color={props.color}
                onSelect={handleSelectBrb}
                height="100%"
                witdh="25%"
              />
            ) : (
              <FormBankMobile
                src="./assets/brb.svg"
                firstNameTax="Bonificada LTV <= 70%"
                thirdNameTax="Balcão"
                firstTax={firstTaxBrb}
                thirdTax={thirdTaxBrb}
                firstId={24}
                secondId={26}
                thirdId={1}
                color={props.color}
                onSelect={handleSelectBrb}
                height="100%"
                witdh="25%"
              />
            )}

            {ltvAceito && valorFinanciamento.length != 0 ? (
              <FormBankMobile
                src="./assets/bradesco.svg"
                firstNameTax="Bradesco Private / Principal"
                secondNameTax="Bradesco Prime / Exclusive"
                thirdNameTax="Bradesco Classic"
                disabled={true}
                firstTax={firstTaxBradesco}
                secondTax={secondTaxBradesco}
                thirdTax={thirdTaxBradesco}
                onSelect={handleSelectBradesco}
                color={props.color}
                firstId={6}
                secondId={20}
                thirdId={21}
                height="50%"
                witdh="50%"
              />
            ) : (
              <FormBankMobile
                src="./assets/bradesco.svg"
                firstNameTax="Bradesco Private / Principal"
                secondNameTax="Bradesco Prime / Exclusive"
                thirdNameTax="Bradesco Classic"
                firstTax={firstTaxBradesco}
                secondTax={secondTaxBradesco}
                thirdTax={thirdTaxBradesco}
                onSelect={handleSelectBradesco}
                color={props.color}
                firstId={6}
                secondId={20}
                thirdId={21}
                height="50%"
                witdh="50%"
              />
            )}

            {ltvAceito && valorFinanciamento.length != 0 ? (
              <FormBankMobile
                src="./assets/caixa.svg"
                firstNameTax="Plus"
                secondNameTax="Relacionamento"
                thirdNameTax="Balcão"
                fourthNameTax="Customizada"
                firstTax={firstTaxCaixa}
                secondTax={secondTaxCaixa}
                thirdTax={thirdTaxCaixa}
                disabled={true}
                firstId={30}
                secondId={7}
                thirdId={33}
                color={props.color}
                onSelect={handleSelectCaixa}
                height="25%"
                witdh="25%"
              />
            ) : (
              <FormBankMobile
                src="./assets/caixa.svg"
                firstNameTax="Plus"
                secondNameTax="Relacionamento"
                thirdNameTax="Balcão"
                fourthNameTax="Customizada"
                firstTax={firstTaxCaixa}
                secondTax={secondTaxCaixa}
                thirdTax={thirdTaxCaixa}
                firstId={30}
                secondId={7}
                thirdId={33}
                color={props.color}
                onSelect={handleSelectCaixa}
                height="25%"
                witdh="25%"
              />
            )}

            <FormBankMobile
              src="./assets/inter.svg"
              firstNameTax="Balcão"
              firstTax={firstTaxInter}
              firstId={12}
              onSelect={handleSelectInter}
              color={props.color}
              height="25%"
              witdh="25%"
            />
            <FormBankMobile
              src="./assets/santander.svg"
              firstNameTax="Taxa Bonificada"
              secondNameTax="Santander balcão"
              firstTax={firstTaxSantander}
              secondTax={secondTaxSantander}
              firstId={4}
              secondId={23}
              onSelect={handleSelectSantander}
              color={props.color}
              height="25%"
              witdh="25%"
            />
            <div>
              <FormBankMobile
                src="./assets/itau.svg"
                firstNameTax="Private"
                secondNameTax="Personnalité  1 a 3"
                thirdNameTax="Personnalité  4 a 5"
                fourthNameTax="Uniclass 1, a 3"
                fifthNameTax="Uniclass 4 a 5 "
                sixthNameTax="Conta Comum"
                firstTax={taxPrivateItau}
                secondTax={taxPersonnalite4e5Itau}
                thirdTax={taxPersonnalite1e3Itau}
                fourthTax={taxUniclass4e5Itau}
                fifthTax={taxUniclass1e3Itau}
                sixthTax={taxBalcaoItau}
                firstId={29}
                secondId={27}
                thirdId={5}
                fourthId={28}
                fifthId={18}
                sixthId={19}
                onSelect={handleSelectItau}
                color={props.color}
                height="25%"
                witdh="25%"
              />
              {buttonTaxIsErro && (
                <p
                  style={{
                    fontSize: "12px",
                    fontWeight: "400",
                    fontFamily: "inter",
                    letterSpacing: "0px",
                    lineHeight: "normal",
                    color: "RED ",
                  }}
                >
                  * Por favor, selecione um banco
                </p>
              )}
              <p
                style={{
                  padding: "0 16px",
                  maxWidth: "737px",
                  fontSize: "14px",
                  fontWeight: "400",
                  fontFamily: "Inter, sans-serif",
                  letterSpacing: "-0.3px",
                  lineHeight: "1.5",
                  margin: "16px auto",
                  textAlign: "left",
                }}
              >
                A simulação de financiamento é apenas uma estimativa. As
                condições reais (valores, taxas e parcelas) só são definidas
                após a análise de crédito. Custos como avaliação do imóvel podem
                ser cobrados mesmo em caso de desistência. Todos os valores
                estão sujeitos a mudanças conforme o perfil do cliente,
                correções monetárias e regras do banco. Ao apertar em Simular,
                você confirma que entende esses termos.
              </p>
              {ltvAceito && valorFinanciamento.length != 0 ? (
                <div className=" m-3">
                  <WarningLTV
                    name={"Bradesco"}
                    warning={"Aceita somente LTV abaixo de 70%"}
                  />
                  <WarningLTV
                    name={"Caixa"}
                    warning={"Aceita somente LTV abaixo de 70%"}
                  />
                </div>
              ) : null}
            </div>
          </Col>
        ) : cgi == "FIN" && selectInter == "INTER" ? (
          <div className=" d-md-none m-2">
            <Col
              className=" d-md-none m-2"
              style={{ padding: "0px 0px 0px 16px " }}
            >
              <FormBankMobile
                src="./assets/inter.svg"
                firstNameTax="IPCA"
                firstTax={firstTaxInterFin}
                firstId={12}
                onSelect={handleSelectInter}
                color={props.color}
                height="25%"
                witdh="25%"
              />
            </Col>
            {buttonTaxIsErro && (
              <p
                style={{
                  fontSize: "12px",
                  fontWeight: "400",
                  fontFamily: "inter",
                  letterSpacing: "0px",
                  lineHeight: "normal",
                  color: "RED ",
                }}
              >
                * Por favor, selecione um banco
              </p>
            )}
            <p
              style={{
                paddingInlineStart: "25px",
                width: "737px",
                fontSize: "12px",
                fontWeight: "400",
                fontFamily: "inter",
                letterSpacing: "-0.7px",
                lineHeight: "normal",
              }}
            >
              A simulação de financiamento é apenas uma estimativa. As condições
              reais (valores, taxas e parcelas) só são definidas após a análise
              de crédito. Custos como avaliação do imóvel podem ser cobrados
              mesmo em caso de desistência. Todos os valores estão sujeitos a
              mudanças conforme o perfil do cliente, correções monetárias e
              regras do banco. Ao apertar em Simular, você confirma que entende
              esses termos.
            </p>
          </div>
        ) : cgi === "CGI" && selectInter === "INTER" ? (
          <div className=" d-md-none m-2">
            <Col
              className=" d-md-none m-2"
              style={{ padding: "0px 0px 0px 16px " }}
            >
              <FormBankMobile
                src="./assets/inter.svg"
                firstNameTax="IPCA"
                firstTax={fisrtTaxInterCGI}
                firstId={12}
                onSelect={handleSelectInter}
                color={props.color}
                height="25%"
                witdh="25%"
              />
            </Col>
            {buttonTaxIsErro && (
              <p
                style={{
                  fontSize: "12px",
                  fontWeight: "400",
                  fontFamily: "inter",
                  letterSpacing: "0px",
                  lineHeight: "normal",
                  color: "RED ",
                }}
              >
                * Por favor, selecione um banco
              </p>
            )}
            <p
              style={{
                paddingInlineStart: "25px",
                width: "737px",
                fontSize: "12px",
                fontWeight: "400",
                fontFamily: "inter",
                letterSpacing: "-0.7px",
                lineHeight: "normal",
              }}
            >
              A simulação de financiamento é apenas uma estimativa. As condições
              reais (valores, taxas e parcelas) só são definidas após a análise
              de crédito. Custos como avaliação do imóvel podem ser cobrados
              mesmo em caso de desistência. Todos os valores estão sujeitos a
              mudanças conforme o perfil do cliente, correções monetárias e
              regras do banco. Ao apertar em Simular, você confirma que entende
              esses termos.
            </p>
          </div>
        ) : null}
      </Row>
    </Container>
  );
};

export default FormFinancingBank;
